/* ITALIAN HOUSE storefront behaviour.

   Sets html.adria-js synchronously, which is the ONLY thing that arms the
   scroll reveal. If this file fails to load, adria.css leaves every section
   fully visible. The flag is set only after confirming IntersectionObserver
   exists, so an old browser is never left with hidden content. */
(function () {
  'use strict';

  var root = document.documentElement;
  var supported =
    'IntersectionObserver' in window &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!supported) return;

  root.classList.add('adria-js');

  function arm() {
    var targets = document.querySelectorAll('.adria-reveal:not(.is-visible)');
    if (!targets.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      // Anything already in view on load reveals immediately, so the hero is
      // never animated in after the user is already looking at it.
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight * 0.92) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm, { once: true });
  } else {
    arm();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', arm);
})();
